import React from 'react';

import { GridEventListener, GridRowParams } from '@mui/x-data-grid';

import { reverse } from 'named-urls';

import Grid from 'components/Grid';
import { ColumnDefinition } from 'components/Grid/types';
import { LIBRARY_INCLUDE_ARCHIVED, LIBRARY_NOT_ARCHIVED_FILTERS } from 'components/Grid/libraryFilters';

import { useStore } from 'utils/hooks/store';

import routes from 'core/routes';

import HazardActionCell from '../HazardActionCell';

import { HAZARD_FIELD } from '../../constants';
import { HazardRow } from '../../types';

import { basicHazardsColumns } from './columns';
import { HazardsTableProps } from './types';

const HazardsTable: React.FunctionComponent<HazardsTableProps> = ({
  onError,
  onRefreshCallback,
}): React.ReactElement => {
  const { routing } = useStore();

  const onRowClick: GridEventListener<'rowClick'> = (item: GridRowParams): void => {
    routing.push(reverse(routes.dashboard.risks.hazardDetails, { entityId: item.id }));
  };

  return (
    <Grid
      basicColumns={
        [
          ...basicHazardsColumns,
          {
            field: 'actions',
            type: 'actions',
            headerName: '',
            maxWidth: 50,
            ariaLabel: 'actions_cell',
            renderCell: ({ row, colDef }: { row: HazardRow; colDef: ColumnDefinition }) => (
              <HazardActionCell rowData={row} actions={colDef.actions} />
            ),
            filterOperators: null,
            sortable: false,
          },
        ] as unknown as ColumnDefinition[]
      }
      entity="hazards"
      isEntityList
      filters={LIBRARY_NOT_ARCHIVED_FILTERS}
      temporaryFilters={LIBRARY_INCLUDE_ARCHIVED}
      preferencesVersion={2}
      sortBy={{ field: HAZARD_FIELD.name, sort: 'asc' }}
      onError={onError}
      dataURL="/api/entities/hazards/"
      fieldsURL="/api/entities/hazards/fields/"
      customNoRowsText="No hazards have been created yet"
      onRowClick={onRowClick}
      onRefreshCallback={onRefreshCallback}
      disableSelectAllColumns
      testId="hazards-grid"
    />
  );
};

export default HazardsTable;
